import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { createAuthClient } from 'better-auth/client';
import { Observable } from 'rxjs';

import { environment } from '../../../assets/environments/environment';
import type { OrganizationRegistrationPayload } from '../../types/interfaces/auth/organization-registration-payload';
import type { RegisterBusinessOrAgencyResponse } from '../../types/interfaces/auth/register-business-or-agency-response';

const authClient = createAuthClient({
  baseURL: environment.apiBaseUrl.replace(/\/api$/, ''),
  basePath: `/api/${environment.apiVersion}/auth`,
  fetchOptions: {
    credentials: 'include',
  },
});

@Injectable({
  providedIn: 'root',
})
export class Auth {
  private readonly http = inject(HttpClient);

  readonly client = authClient;

  registerOrganization(
    body: OrganizationRegistrationPayload,
  ): Observable<RegisterBusinessOrAgencyResponse> {
    const url = `${environment.apiBaseUrl}/${environment.apiVersion}/registration/organization`;
    return this.http.post<RegisterBusinessOrAgencyResponse>(url, body, {
      withCredentials: true,
    });
  }

  signUpEmail(body: {
    email: string;
    password: string;
    name: string;
    image?: string;
    callbackURL?: string;
  }) {
    return this.client.signUp.email(body);
  }

  signInEmail(body: { email: string; password: string }) {
    return this.client.signIn.email(body);
  }

  signInGoogle(callbackURL = '/') {
    return this.client.signIn.social({
      provider: 'google',
      callbackURL,
    });
  }

  getSession() {
    return this.client.getSession();
  }

  signOut() {
    return this.client.signOut();
  }

  updateUser(body: { name?: string; image?: string }) {
    return this.client.updateUser(body);
  }

  changePassword(body: {
    currentPassword: string;
    newPassword: string;
    revokeOtherSessions?: boolean;
  }) {
    return this.client.changePassword(body);
  }

  changeEmail(body: { newEmail: string; callbackURL?: string }) {
    return this.client.changeEmail(body);
  }
}
